export default "__VITE_ASSET__CmTmgIRK__"